import api from './api';

export type InfoCategory = 'GLOBAL' | 'LOCAL';

export interface InfoItem {
  id: string;
  category: InfoCategory;
  title: string;
  documentUrl: string;
  displayOrder: number;
  uploadedBy?: {
    id: string;
    fullName: string;
  };
  createdAt: string;
  updatedAt: string;
}

export const infoItemsService = {
  async getAll(): Promise<InfoItem[]> {
    const response = await api.get('/info-items');
    return response.data;
  },

  async getById(id: string): Promise<InfoItem> {
    const response = await api.get(`/info-items/${id}`);
    return response.data;
  },

  async create(data: { category: InfoCategory; title: string; documentUrl: string; displayOrder?: number }): Promise<InfoItem> {
    const response = await api.post('/info-items', data);
    return response.data;
  },

  async uploadDocument(file: File): Promise<{ url: string }> {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/info-items/upload', formData);
    return response.data;
  },

  async update(id: string, data: Partial<InfoItem>): Promise<InfoItem> {
    const response = await api.patch(`/info-items/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/info-items/${id}`);
  },
};
